import React from "react";

import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const ViewDetailedBtn = ( { onClick } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<Typography
			className = { `${ classes.footer } fontBold` }
			onClick   = { onClick }
			title     = { "View Detailed" }
		/>
	);
};

export default ViewDetailedBtn;
